import './style.scss';
import { HomeRightItem } from '../right-item';
import { IProjectDocInfo } from '../../../../model/api-modules/document';
import { LanguageType } from '../../../../model';
import { LanguageType as langType } from '../../../../lib';

interface IProps {
  readonly projectDocInfo: IProjectDocInfo | undefined;
  readonly isDocPublicRoute: boolean;
  readonly lang: LanguageType | null;
}
export const DocumentHomeRight = (props: IProps) => {
  const lang = props.lang === LanguageType.ZH ? langType.zh_CN : langType.en_US;
  return (
    <div className="document-home-right">
      {props?.projectDocInfo?.menu &&
        props?.projectDocInfo?.menu.map((item) => {
          return (
            <HomeRightItem
              menu={item}
              isDocPublicRoute={props.isDocPublicRoute}
              lang={lang}
            />
          );
        })}
    </div>
  );
};
